<template>
  <b-container fluid v-bind:class="'logEntries ' + meetingStatus">
    <b-row class="logEntry" v-for="logItem in logItems" v-bind:key="logItem.id" align-h="center" no-gutters @mouseover="currentLogItem=logItem.id" @mouseout="currentLogItem=''">
      <b-col cols="11">
        <font-awesome-icon v-if="logItem.logType=='action'  && logItem.actionStatus != 'complete'" :icon="['far', 'square']" size="1x" @click="markActionComplete(logItem)" style="color:red" v-b-tooltip.hover title="Mark this action complete" data-html2canvas-ignore/>
        <font-awesome-icon v-if="logItem.logType=='action'  && logItem.actionStatus == 'complete'" :icon="['far', 'check-square']" size="1x" style="xfloat:right;color:green" v-b-tooltip.hover title="Action complete" data-html2canvas-ignore/>
        &nbsp;{{logItem.text}}
        <div v-if="logItem.owner && logItem.owner.name">Owner: {{logItem.owner.name}}</div>
        <div v-else-if="logItem.owner">Owner: {{logItem.owner}}</div>
        <div v-if="logItem.date">Due Date: {{logItem.date}}</div>
    </b-col>
    <b-col align-h="end"  align-v="center" cols="1" style="display:flex; align-items: center; justify-content:flex-end">
      <font-awesome-icon v-b-tooltip.hover title="Remove item" variant="outline-success" v-show="logItem.id == currentLogItem" id="removeLogItem" :icon="['far', 'trash-alt']"  size="1x" @click="removeLogItem(logItem)" style="float:right;color:#afadad" class="deleteLogItem" />
      <br>
    </b-col>
  </b-row>
  </b-container>
</template>
<script>
export default {
  props: ['logItems', 'meetingStatus'],
  data () {
    return {
      // logItems: this.logItems,
      // meetingStatus: this.meetingStatus,
      currentLogItem: ''
    }
  },
  methods: {
    markActionComplete (logItem) {
      this.$emit('markActionComplete',logItem)
    },
    setLogType (logType) {
      this.logItem.logType = logType
    },
    removeLogItem (logItem) {
      this.$bvModal.msgBoxConfirm('Delete this item?').then( value  => {
        if (value) this.$emit('removeLogItem', logItem)
      })
    }
  }
}
</script>
<style scoped>
  .logEntries.container-fluid{margin:0px;padding: 0px;}
  .logEntry .container-fluid{margin:0px;padding: 0px}
  .logEntry{background-color: white; border-radius: 5px; padding: 3px 6px;margin:8px 0px}
  .deleteLogItem {cursor:pointer}
</style>
